import React, { useState } from 'react';
import WordTagPicker from '../../widgets/WordTagPicker';
import PhotoPicker from '../../widgets/PhotoPicker';
import MagicRevealCard from '../../widgets/MagicRevealCard';
import EntryForm from '../../widgets/EntryForm';
import Carousel from '../../widgets/Carousel';
import Footer from '../../widgets/Footer';
import MagicHeader from '../../widgets/MagicHeader';
import StepDots from '../../widgets/StepDots';
import { saveMoment } from '../../widgets/MomentsCart';
import '../magic.css';

const PRESET_PHOTOS = [
  '/assets/images/templates/magic-preset-1.jpg',
  '/assets/images/templates/magic-preset-2.jpg',
  '/assets/images/templates/magic-preset-3.jpg'
];

// One dot per wizard step (words → photo → reveal); the code-entry step is a separate flow.
const WIZARD_STEPS = ['words', 'photo', 'reveal'];

// Wizard: word picker → photo picker → shareable reveal card → real code entry
const Entry = () => {
  const [step, setStep] = useState('words');
  const [words, setWords] = useState([]);
  const [photo, setPhoto] = useState(null);

  const stepIndex = WIZARD_STEPS.indexOf(step);

  return (
    <div className="magic-theme">
      <MagicHeader
        variant="dark"
        showBack={step === 'photo' || step === 'reveal'}
        onBack={() => setStep(step === 'reveal' ? 'photo' : 'words')}
        hideActions={step === 'reveal'}
      />

      <main className="strict-width position-relative">
        {step === 'words' && (
          <WordTagPicker
            onNext={(selected) => {
              setWords(selected);
              setStep('photo');
            }}
          >
            <Carousel />
          </WordTagPicker>
        )}

        {step === 'photo' && (
          <PhotoPicker
            photos={PRESET_PHOTOS}
            onBack={() => setStep('words')}
            onNext={(selected) => {
              setPhoto(selected);
              setStep('reveal');
            }}
          />
        )}

        {step === 'reveal' && (
          <MagicRevealCard
            photo={photo}
            photos={[photo, ...PRESET_PHOTOS.filter((p) => p !== photo)]}
            words={words}
            onContinue={() => {
              saveMoment({ photo, words, productLine: 'Ice-cold Coke' });
              setStep('code');
            }}
          />
        )}

        {stepIndex >= 0 && <StepDots total={WIZARD_STEPS.length} activeIndex={stepIndex} className="magic-step-dots" />}

        {step === 'code' && (
          <div className="magic-code-entry">
            <div className="text-center mb-4">
              <h4 className="title">Enter Details</h4>
              <h6 className="subtitle fw-light fs-6">for a chance to win</h6>
            </div>
            <EntryForm />
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
};

export default Entry;
